import { TokenData } from "../types";

const TOKEN_EXCHANGE_URL = process.env.REACT_APP_TREEZ_TOKEN_EXCHANGE_URL;

export const exchangeToken = async (code: string): Promise<TokenData> => {
    const response = await fetch(`${TOKEN_EXCHANGE_URL}`, {
        headers: {
            "x-application": "MSO",
            "Content-Type": "application/json",
            code: code,
        },
    });
    if (!response.ok) {
        throw new Error("Token exchange failed");
    }
    const data = await response.json();
    return data;
};
